$('.product-single__swatch__input').click(function() {
    var current_var_id  = $(this).context.value;
    if(current_var_id != '' && current_var_id != undefined){ 
      //SwymPageData.epi = current_var_id;
      $('.swym-button').attr('data-variant-id', current_var_id);
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + current_var_id;
	  window.history.replaceState({path: newurl}, '', newurl);
      _swat.initializeActionButtons("body");
    }
  });